import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Button, ButtonGroup, Tooltip, Grow, Paper, Popper, MenuItem, MenuList, } from '@mui/material';
import { ButtonWithTracking, } from '../ButtonWithTracking';
/**
 * This component implements a Dropdown button using MUI (This can be removed as soon as MUI implements it. Check
 * progress: https://mui.com/material-ui/discover-more/roadmap/#new-components)
 */
export var DropDownButton = function (_a) {
    var items = _a.items, _b = _a.selectedItemIndex, selectedItemIndex = _b === void 0 ? 0 : _b, onClick = _a.onClick, buttonGroupProps = __rest(_a, ["items", "selectedItemIndex", "onClick"]);
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var anchorRef = React.useRef(null);
    var _d = React.useState(selectedItemIndex), selectedIndex = _d[0], setSelectedIndex = _d[1];
    var handleClick = function (event) {
        var _a, _b;
        return ((_b = (_a = items[selectedIndex]).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event)) ||
            (onClick === null || onClick === void 0 ? void 0 : onClick(event, items[selectedIndex]));
    };
    var handleMenuItemClick = function (index) {
        setSelectedIndex(index);
        setOpen(false);
    };
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
    };
    var handleClose = function (event) {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    return (_jsxs(React.Fragment, { children: [_jsxs(ButtonGroup, __assign({ variant: "contained", ref: anchorRef, "aria-label": "split button", disableElevation: true }, buttonGroupProps, { children: [_jsx(Tooltip, __assign({ title: items[selectedIndex].tooltip }, { children: _jsx(ButtonWithTracking, __assign({ onClick: handleClick, eventName: items[selectedIndex].eventName, eventProperties: items[selectedIndex].eventProperties }, { children: items[selectedIndex].children })) })), _jsx(Button, __assign({ size: "small", "aria-controls": open ? 'split-button-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-label": "actions", "aria-haspopup": "menu", onClick: handleToggle }, { children: _jsx(ArrowDropDownIcon, {}) }))] })), _jsx(Popper, __assign({ sx: {
                    zIndex: 1,
                }, open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true }, { children: function (_a) {
                    var TransitionProps = _a.TransitionProps, placement = _a.placement;
                    return (_jsx(Grow, __assign({}, TransitionProps, { style: {
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        } }, { children: _jsx(Paper, { children: _jsx(ClickAwayListener, __assign({ onClickAway: handleClose }, { children: _jsx(MenuList, __assign({ id: "split-button-menu", autoFocusItem: true }, { children: items.map(function (option, index) {
                                        var _a, _b;
                                        return (_jsx(Tooltip, __assign({ title: option.tooltip }, { children: _jsx(MenuItem, __assign({ disabled: option.disabled, selected: index === selectedIndex, onClick: function () { return handleMenuItemClick(index); } }, { children: option.children }), (_b = (_a = option.id) !== null && _a !== void 0 ? _a : option.key) !== null && _b !== void 0 ? _b : index) })));
                                    }) })) })) }) })));
                } }))] }));
};
